import React, { useEffect } from 'react';
import { useApi } from '@backend/api';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import './timeline.scss';

import Carriage from '../../svg/wedding-icons/__Carriage.svg';
import Balloons from '../../svg/wedding-icons/__Balloons.svg';
import Weddingarch1 from '../../svg/wedding-icons/__Weddingarch1.svg';
import Weddingcake2 from '../../svg/wedding-icons/__Weddingcake2.svg';
import Ringsheart from '../../svg/wedding-icons/__Ringsheart.svg';
import Grooms from '../../svg/wedding-icons/__Grooms2.svg';
import Toast from '../../svg/wedding-icons/__Toast.svg';
import Photos from '../../svg/wedding-icons/__Photos.svg';
import Camera from '../../svg/wedding-icons/__Camera.svg';
import Flower from '../../svg/wedding-icons/__Flower.svg';
import Rings from '../../svg/wedding-icons/rings.svg';
import Silverplatter from '../../svg/wedding-icons/__Silverplatter.svg';
import Glitterball2 from '../../svg/wedding-icons/__Glitterball2.svg';
import Bouquet from '../../svg/wedding-icons/__Bouquet.svg';
import Party from '../../svg/wedding-icons/__Heartsconfetti.svg';
import { useEventContext, useUserContext } from '@event-images/shared';
import { Link } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export interface MTimeLineProps {}

const myIcons: any = {
  Carriage: <Carriage />,
  Balloons: <Balloons />,
  Weddingarch: <Weddingarch1 />,
  Weddingcake: <Weddingcake2 />,
  Toast: <Toast />,
  Ringsheart: <Ringsheart />,
  Grooms: <Grooms />,
  Photos: <Photos />,
  Camera: <Camera />,
  Flower: <Flower />,
  Silverplatter: <img src={'/cats.png'} />,
  Glitterball2: <Glitterball2 />,
  Bouquet: <Bouquet />,
  Party: <Party />,
};

export interface MTimeLine {
  id: number;
  time: string;
  title: string;
  icon: string;
}

const myTimeLine: MTimeLine[] = [
  {
    id: 10,
    time: '13:00',
    title: 'Eintreffen',
    icon: 'Carriage',
  },
  {
    id: 20,
    time: '14:00 (Insel bei Badeteich)',
    title: 'Trauung',
    icon: 'Ringsheart',
  },
  {
    id: 30,
    time: 'Ca. 15:00 (Csarda)',
    title: 'Agape & Torten anschneiden ',
    icon: 'Toast',
  },
  {
    id: 40,
    time: '16:30',
    title: 'Paarshooting',
    icon: 'Grooms',
  },
  {
    id: 90,
    time: '18:30',
    title: 'Abendessen',
    icon: 'Silverplatter',
  },
  {
    id: 100,
    time: '20:30',
    title: 'Dancefloor-Eröffnung',
    icon: 'Glitterball2',
  },
  {
    id: 13,
    time: 'Ca. 2:00',
    title: 'Ende',
    icon: 'Party',
  },
];

export const MyTimeLine = (props: MTimeLineProps) => {
  const api = useApi();
  const { setCurrentTitle, albums } = useEventContext();
  const { user } = useUserContext();

  useEffect(() => {
    setCurrentTitle(undefined);
  }, [setCurrentTitle]);
  if (!albums?.length) {
    return null;
  }

  return (
    <div className={'startpage'}>
      <div className={'text-block-2 text-block-2a'}>
        <div className={'header-title'}> Liebe Hochzeitsgäste,</div>

        <div className={'p'}>
          wir heißen euch herzlich Willkommen auf unserer Homepage!
        </div>
        <div className={'p'}>
          Diese Plattform dient vor allem zum Fotoaustausch (hochladen,
          downloaden,...), daher hat jeder von euch auch eine persönliche
          Fotochallenge-Aufgabe unten stehen.
        </div>
        <div className={'p p1'}>Wir bitten euch diese brav umzusetzen!</div>
        <div className={'p'}>Viel Spaß und auf einen schönen Tag</div>
        <div className={'p text-rings1'}>Liebste Grüße,</div>
        <div className={'text-rings'}>
          Klara & Sascha
          <Rings />
        </div>
        {!!user?.assignedChallenge && (
          <>
            <div className={'p'}>Deine Fotochallenge</div>
            <div className={'challenges'}>
              <Link
                to={'/challenges/' + user.assignedChallenge.id}
                key={user.assignedChallenge.id}
              >
                <div className={'challenge-1'}>
                  <div className={'challenge-1a'}>
                    <div className={'text'}>{user.assignedChallenge.text}</div>
                    <div className={'arrow'}>
                      <ArrowForwardIosIcon />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </>
        )}
      </div>

      <div className={'timeline-container'}>
        <div className={'header-title'}>Hochzeits-Ablauf</div>

        <VerticalTimeline lineColor={'#ffffff'}>
          {myTimeLine.map((item) => {
            return (
              <VerticalTimelineElement
                key={'x' + item.id}
                date={'' + item.time}
                iconStyle={{}}
                icon={myIcons[item.icon]}
              >
                <h3 className="vertical-timeline-element-title">
                  {item.title}
                </h3>
              </VerticalTimelineElement>
            );
          })}
        </VerticalTimeline>
        <div className={'skeleton--center-image-container'}>
          <div className={'header-x'}>
            <div className={'header-x--0'}>
              <div className={'header-x--1'}>14.06.</div>
              <img className={'header-x--2'} src={'/cats.png'} />
              <div className={'header-x--3'}>2025</div>
            </div>
            <div className={'header-x--4'}>Grillmeister</div>
          </div>
        </div>

        <div className={'made-with-love-1'}>With ❤️ from Vienna</div>
      </div>
    </div>
  );
};
